var _defs, _polygon, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskReleased24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#009AD9;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TaskReleased_24") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "15 23 9 23 9 16 6 16 12 10 18 16 15 16 15 23"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3,16.18,4.48,14.7A4,4,0,0,1,6,7h.71A5.5,5.5,0,0,1,17.5,8.5V9H19a3,3,0,0,1,.73,5.9l1.53,1.53A5,5,0,0,0,19.35,7a7.49,7.49,0,0,0-14-2A6,6,0,0,0,3,16.18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskReleased24);
export default __webpack_public_path__ + "static/media/TaskReleased_24.be0bce648f7f7b0e42fbbdae2ec0d53a.svg";
export { ForwardRef as ReactComponent };